export default function translate(i18n, propriete) {
  if (propriete === 'code') return i18n.t('addEditMarche.information.code');
  if (propriete === 'libelle') return i18n.t('addEditMarche.information.libelle');
  if (propriete === 'dateDebut') return i18n.t('addEditMarche.information.dateDebut');
  if (propriete === 'dateFin') return i18n.t('addEditMarche.information.dateFin');
  if (propriete === 'fournisseurId') return i18n.t('addEditMarche.information.fournisseur');
  if (propriete === 'regleFacturationId') return i18n.t('addEditMarche.information.regleFacturation');
  if (propriete.includes('FournisseurId')) return i18n.t('addEditMarche.information.fournisseur');
  return propriete;
}
